import SuperRepository from '../superRepository'

export default new (class BudgetReportRepository extends SuperRepository {
    baseUri() {
        return 'partner_budget'
    }
})()
